import { homeMock } from '@/mocks/home';

export default function Hero() {
  const letters = homeMock.shopName.replace(/\s/g, '').split('');

  return (
    <section className="relative w-full h-screen min-h-[640px] overflow-hidden bg-mahjong-dark">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={homeMock.hero.image}
          alt="雀荘 和の内装"
          className="w-full h-full object-cover object-top animate-ken-burns"
        />
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-black/65 via-black/40 to-black/75" />
      </div>

      <div className="absolute right-6 top-1/2 z-10 flex -translate-y-1/2 items-center gap-6 md:right-16 md:gap-10">
        <p className="mt-auto hidden text-xs tracking-[0.5em] text-white/55 md:block">
          -- {homeMock.shopNameReading}
        </p>
        <div className="h-[54vh] w-px bg-white/30" />
        <h1
          className="flex flex-col items-center gap-1 font-serif text-[5.5rem] font-bold leading-none text-white md:text-[9rem] lg:text-[11rem]"
          style={{ writingMode: 'vertical-rl', textOrientation: 'mixed' }}
          aria-label={homeMock.shopName}
        >
          {letters.map((letter, index) => (
            <span
              key={`${letter}-${index}`}
              className="block opacity-0 animate-vertical-reveal"
              style={{ animationDelay: `${index * 180}ms` }}
            >
              {letter}
            </span>
          ))}
        </h1>
      </div>

      <div className="absolute left-6 top-28 z-10 h-24 w-24 rounded-full border border-white/10 bg-white/5 blur-sm md:left-16 md:top-36" />
      <div className="absolute bottom-32 left-[18%] z-10 h-40 w-40 rounded-full bg-mahjong-accent/10 blur-3xl" />

      <div className="absolute bottom-8 left-6 z-10 flex items-end gap-3 md:left-16 md:bottom-12">
        <span
          className="text-[10px] tracking-[0.35em] text-white/55"
          style={{ writingMode: 'vertical-rl' }}
        >
          SCROLL
        </span>
        <div className="h-20 w-px overflow-hidden bg-white/20">
          <div className="h-8 w-px animate-bounce bg-white/70" />
        </div>
      </div>
    </section>
  );
}